import { useCallback } from 'react';
import { IconClose } from '../../icon/IconClose';
import { Box } from '../../layout/Box';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';
import { InputTextButtonProps } from './types';

export const InputTextButton: React.FC<InputTextButtonProps> = ({
    text,
    value,
    onClick,
    ...other
}) => {
    const onIconClick = useCallback(() => {
        onClick(value);
    }, [value, onClick]);

    return (
        <Wrapper {...other} mr={1} minWidth={0} maxWidth="100%" whiteSpace="nowrap">
            <Typography
                variant="body2"
                weight="regular"
                minWidth={0}
                overflow="hidden"
                textOverflow="ellipsis"
            >
                {text}
            </Typography>
            <Box p={1} onClick={onIconClick}>
                <IconClose size={16} />
            </Box>
        </Wrapper>
    );
};
